export const localText = {
  // Root
  rootGridLabel: 'جدول',

  // Density selector toolbar button text
  toolbarDensity: 'تراکم',
  toolbarDensityLabel: 'تراکم',
  toolbarDensityCompact: 'فشرده',
  toolbarDensityStandard: 'استاندارد',
  toolbarDensityComfortable: 'راحت',

  // Columns selector toolbar button text
  toolbarColumns: 'ستون‌ها',
  toolbarColumnsLabel: 'نمایش‌انتخابگر‌ستون‌ها',

  // Filters toolbar button text
  toolbarFilters: 'فیلترها',
  toolbarFiltersLabel: 'نمایش‌فیلترها',
  toolbarFiltersTooltipHide: 'پنهان‌کردن‌فیلترها',
  toolbarFiltersTooltipShow: 'نمایش‌فیلترها',
  toolbarFiltersTooltipActive: (count) => `${count} تعداد‌فیلتر`,

  // Columns panel text
  columnsPanelTextFieldLabel: 'جستجو‌ستون',
  columnsPanelTextFieldPlaceholder: 'عنوان‌ستون',
  columnsPanelDragIconLabel: 'ترتیب‌مجدد‌ستون‌ها',
  columnsPanelShowAllButton: 'نمایش‌همه',
  columnsPanelHideAllButton: 'پنهان‌سازی‌همه',

  // Filter panel text
  filterPanelAddFilter: 'افزودن‌فیلتر',
  filterPanelDeleteIconLabel: 'حذف',
  filterPanelOperators: 'عملگرها',
  filterPanelOperatorAnd: 'و',
  filterPanelOperatorOr: 'یا',
  filterPanelColumns: 'ستون‌ها',

  // Column menu text
  columnMenuLabel: 'منو',
  columnMenuShowColumns: 'نمایش ستون‌ها',
  columnMenuFilter: 'فیلتر',
  columnMenuHideColumn: 'پنهان‌کردن',
  columnMenuUnsort: 'بدون ترتیب',
  columnMenuSortAsc: 'بترتیب صعودی',
  columnMenuSortDesc: 'بترتیب نزولی',

  // Column header text
  columnHeaderFiltersTooltipActive: (count) => `${count} تعداد فیلتر`,
  columnHeaderFiltersLabel: 'نمایش فیلتر‌ها',
  columnHeaderSortIconLabel: 'مرتب‌سازی',

  // Rows selected footer text
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} تعداد‌ ردیف انتخاب‌شده`
      : `${count.toLocaleString()} ردیف انتخاب شده`,

  // Total rows footer text
  footerTotalRows: 'تعداد ردیف‌ها:',

  // Pagination footer text
  footerPaginationRowsPerPage: 'ردیف‌هادرهرصفحه:',
};
